import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: ''
}

// getters
const getters = {
  allBanners: state => state.all
}

// actions
const actions = {
  receiveBanners ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flag, state.time, types.RECEIVE_BANNERS)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_BANNERS] (state, banners) {
    state.all = banners
    state.flag = true
    state.time = new Date().getTime()
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/banners.js